export const pastelWavesSvg = encodeURIComponent(`
<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 800' preserveAspectRatio='none'>
  <defs>
    <radialGradient id='bg1' cx='20%' cy='20%' r='80%'>
      <stop offset='0%' stop-color='rgba(153, 0, 31, 0.3)'/>
      <stop offset='100%' stop-color='rgba(153, 0, 31, 0)'/>
    </radialGradient>
    <radialGradient id='bg2' cx='80%' cy='60%' r='70%'>
      <stop offset='0%' stop-color='rgba(192, 0, 58, 0.25)'/>
      <stop offset='100%' stop-color='rgba(192, 0, 58, 0)'/>
    </radialGradient>
    <radialGradient id='bg3' cx='50%' cy='90%' r='60%'>
      <stop offset='0%' stop-color='rgba(224, 0, 78, 0.2)'/>
      <stop offset='100%' stop-color='rgba(224, 0, 78, 0)'/>
    </radialGradient>
  </defs>
  <rect width='100%' height='100%' fill='url(#bg1)'/>
  <rect width='100%' height='100%' fill='url(#bg2)'/>
  <rect width='100%' height='100%' fill='url(#bg3)'/>
  <g opacity='0.3' stroke='rgba(255,255,255,0.4)' stroke-width='1' fill='none'>
    ${Array.from(
        { length: 15 },
        (_, i) =>
            `<path d='M-50 ${i * 50} Q 100 ${i * 50 - 20} 250 ${i * 50} T 450 ${i * 50}' opacity='${
                0.8 - i * 0.05
            }'/>`
    ).join("")}
  </g>
</svg>`)

export const sparklesSvg = encodeURIComponent(`
<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1080 1920'>
  <g stroke='white' stroke-opacity='0.55' stroke-width='2'>
    ${[
        [120, 420],
        [260, 700],
        [360, 980],
        [820, 460],
        [900, 820],
        [760, 1180],
        [220, 1260],
        [540, 1460],
        [880, 1560],
        [360, 1680],
        [680, 870],
        [500, 640],
    ]
        .map(
            ([x, y]) => `
      <g>
        <line x1='${x - 10}' y1='${y}' x2='${x + 10}' y2='${y}'/>
        <line x1='${x}' y1='${y - 10}' x2='${x}' y2='${y + 10}'/>
      </g>`
        )
        .join("")}
  </g>
</svg>`)

export const wavesSvg = encodeURIComponent(`
<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 800' preserveAspectRatio='none'>
  <defs>
    <linearGradient id='waveGrad' x1='0%' y1='0%' x2='100%' y2='0%'>
      <stop offset='0%' stop-color='#ff2a6d'/>
      <stop offset='50%' stop-color='#ff6b9d'/>
      <stop offset='100%' stop-color='#c084fc'/>
    </linearGradient>
    <path id='wave' d='M-50 0 Q 50 -30 150 0 T 350 0 T 550 0' fill='none' stroke='url(#waveGrad)' stroke-width='2' opacity='0.4'/>
  </defs>
  <g>
    ${Array.from({ length: 25 }, (_, i) => `<use href='#wave' y='${i * 32}'/>`).join("")}
  </g>
</svg>`)

export const linesSvg = encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 800" preserveAspectRatio="none">
  <defs>
    <linearGradient id="lineGrad" x1="0" y1="0" x2="400" y2="0">
      <stop offset="0" stop-color="#22d3ee"/>
      <stop offset="1" stop-color="#a855f7"/>
    </linearGradient>
    <path id="line" d="M -100 0 C -50 -15 50 -15 100 0 S 250 15 300 0 S 450 -15 500 0" fill="none" stroke="url(#lineGrad)" stroke-width="1.5" opacity="0.6"/>
  </defs>
  <g>
    ${Array.from(
        { length: 20 },
        (_, i) => `<use href='#line' y='${i * 40}' transform='rotate(${i * 2} 200 ${i * 40})'/>`
    ).join("")}
  </g>
</svg>`)

export const cornerFanSvg = encodeURIComponent(`
<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 800' preserveAspectRatio='none'>
  <defs>
    <linearGradient id='mainGrad' x1='0' y1='0' x2='1' y2='1'>
      <stop offset='0%' stop-color='#00c2ff'/>
      <stop offset='55%' stop-color='#007dff'/>
      <stop offset='100%' stop-color='#3a00ff'/>
    </linearGradient>
  </defs>
  <g opacity='0.6'>
    ${[110, 160, 210, 260, 310, 360, 410, 460, 510, 560, 610]
        .map(
            r =>
                `<circle stroke='url(#mainGrad)' stroke-width='2' fill='none' cx='400' cy='0' r='${r}'/>`
        )
        .join("")}
  </g>
</svg>`)

export const auroraSvg = encodeURIComponent(`
<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 800' preserveAspectRatio='none'>
  <defs>
    <linearGradient id='bg' x1='0' y1='0' x2='1' y2='1'>
      <stop offset='0%'  stop-color='#0b1020'/>
      <stop offset='100%' stop-color='#141b35'/>
    </linearGradient>
    <linearGradient id='a1' x1='0' y1='0' x2='1' y2='0'>
      <stop offset='0%'   stop-color='#00f5d4'/>
      <stop offset='50%'  stop-color='#00bbf0'/>
      <stop offset='100%' stop-color='#845ec2'/>
    </linearGradient>
  </defs>
  <rect width='100%' height='100%' fill='url(#bg)'/>
  <g opacity='0.8'>
    <path d='M-50 190 C 100 110, 240 270, 410 190 L 410 800 -50 800 Z' fill='url(#a1)' opacity='0.65'/>
  </g>
</svg>`)

export const ribbonsSvg = encodeURIComponent(`
<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 800' preserveAspectRatio='none'>
  <defs>
    <linearGradient id='bg' x1='0' y1='0' x2='0' y2='1'>
      <stop offset='0%' stop-color='#0e0a1f'/>
      <stop offset='100%' stop-color='#1a1033'/>
    </linearGradient>
    <linearGradient id='r1' x1='0' y1='0' x2='1' y2='1'>
      <stop offset='0%' stop-color='#ff7a00'/>
      <stop offset='60%' stop-color='#ff3d68'/>
      <stop offset='100%' stop-color='#7b2ff7'/>
    </linearGradient>
  </defs>
  <rect width='100%' height='100%' fill='url(#bg)'/>
  <g opacity='0.85'>
    <path d='M-60 210 C 80 130, 260 280, 440 210 L 440 800 -60 800 Z' fill='url(#r1)'/>
  </g>
</svg>`)

export const embersSvg = encodeURIComponent(`
<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 800' preserveAspectRatio='none'>
  <defs>
    <radialGradient id='amber' cx='50%' cy='50%' r='50%'>
      <stop offset='0%' stop-color='#ffc66d' stop-opacity='0.95'/>
      <stop offset='100%' stop-color='#ffc66d' stop-opacity='0'/>
    </radialGradient>
    <radialGradient id='orange' cx='50%' cy='50%' r='50%'>
      <stop offset='0%' stop-color='#ff7a1a' stop-opacity='0.9'/>
      <stop offset='100%' stop-color='#ff7a1a' stop-opacity='0'/>
    </radialGradient>
  </defs>
  <g opacity='0.9'>
    <circle cx='110' cy='260' r='90' fill='url(#amber)'/>
    <circle cx='340' cy='300' r='120' fill='url(#orange)'/>
    <circle cx='180' cy='520' r='110' fill='url(#amber)'/>
    <circle cx='310' cy='680' r='100' fill='url(#orange)'/>
  </g>
</svg>`)

export const lavaFoldsSvg = encodeURIComponent(`
<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 800' preserveAspectRatio='none'>
  <defs>
    <linearGradient id='bg' x1='0' y1='0' x2='0' y2='1'>
      <stop offset='0%' stop-color='#120806'/>
      <stop offset='100%' stop-color='#1b0c0a'/>
    </linearGradient>
    <linearGradient id='hot1' x1='0' y1='0' x2='1' y2='1'>
      <stop offset='0%'   stop-color='#ffb457'/>
      <stop offset='55%'  stop-color='#ff6a2a'/>
      <stop offset='100%' stop-color='#c21f2f'/>
    </linearGradient>
  </defs>
  <rect width='100%' height='100%' fill='url(#bg)'/>
  <g opacity='0.85'>
    <path d='M-70 210 C 60 130, 260 280, 450 210 L 450 800 -70 800 Z' fill='url(#hot1)'/>
  </g>
</svg>`)

export const sweepArcsSvg = encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 800" preserveAspectRatio="none">
  <defs>
    <linearGradient id="strokeGrad" x1="0" y1="0" x2="400" y2="0">
      <stop offset="0" stop-color="#8b5cf6"/>
      <stop offset="1" stop-color="#06b6d4"/>
    </linearGradient>
  </defs>
  <g opacity="0.55">
    ${[
        200, 260, 320, 380, 440, 500, 560, 620, 680, 740, 800, 860, 920, 980, 1040, 1100, 1160,
        1220, 1280,
    ]
        .map(
            r =>
                `<circle cx="-300" cy="800" r="${r}" stroke="url(#strokeGrad)" fill="none" stroke-width="2.5"/>`
        )
        .join("")}
  </g>
</svg>`)
